export const BatchStatus = Object.freeze({
  NOT_PROCESSED: 0, // 未処理
  ASSIGNED: 1, // 割当済
  STARTED: 2, // 開始済
  PROCESSING: 3, // 処理中
  COMPLETED: 4, // 完了済
  FINISHED: 5 // 終了
})



// WEBPACK FOOTER //
// ./src/enums/batch-status.enums.js